export default "__VITE_ASSET__BjqNQgoK__"